module.exports = require("userful-chronos-app-common-js/dist/models/cdm/DestinationsUtils");